import {
	IBaseStepHistory,
	IStepAssignedToUser,
	IStepHistoryComment,
} from "models/StepHistoryDetail";

export class ContractStepHistoryEmitter {
	contractId: number;
	contractStepId: number;
	actionType: string;

	constructor() {
		this.contractId = -1;
		this.contractStepId = -1;
		this.actionType = "";
	}
}

export interface IContractStep extends IBaseStepHistory {
	contractId: number;
	stepStatus: string;
	contractStepId: number;
}

export interface IContractStepHistory {
	contractId: number;
	stepStatus: string;
	contractStepId: number;
	stepNumber: string;
	description: string;
	assignToUsers: IStepAssignedToUser[];
	duration: string;
	averageDuration: string;
	completedDate?: Date;
	completedBy: string;
	stepCompletedInPercentage: number;
	comments: IStepHistoryComment[];
	modulePhaseId: number;
}
